import Command from './command';
import CommandResult from './command-result';
import BackspaceCommand from './backspace';
export default Command.extend({
  processZeroWidth() {
    if (this.get('firstSelectedBlock.isTextType') || this.get('firstSelectedBlock.isListType')) {
      let mutationResult = this.applyActionToFirstSelectedBlock('backspaceWord');
      this.setSelectionToPositionIndex(mutationResult.get('blockRange.startPoint.positionIndex'));
      return CommandResult.create({
        shouldRerender: true
      });
    } else {
      return this._doBackspace();
    }
  },
  processSingleBlock() {
    return this._doBackspace();
  },
  processMultiBlock() {
    return this._doBackspace();
  },
  _doBackspace() {
    return BackspaceCommand.create({
      blockList: this.get('blockList'),
      selection: this.get('selection'),
      config: this.get('config')
    }).run();
  }
});